import { sum } from 'lodash'

import { formatActivityByDevice, formatDataByOs } from '@/pages/SpaceAnalyticsPage/DeviceMetricsSection'

import sumConnectorData from './sumConnectorData'

const SMART_NOTIFICATIONS_SENT = 'Smart Notifications Sent'

const listMetrics = (topic: any, data: any) => {
  const metrics = []
  if (data.length === 0) {
    metrics.push([topic, 'N/A', 0, ''])
  } else {
    for (const item of data) {
      if (topic === SMART_NOTIFICATIONS_SENT) {
        metrics.push([topic, item.connectorName, item.sentNotifications, ''])
      } else {
        metrics.push([topic, item.name, item.value, ''])
      }
    }
  }
  return metrics
}

const calculateDifference = (currentTotal = 0, previousTotal = 0) => {
  if (currentTotal < previousTotal) return `-${Math.round(((previousTotal - currentTotal) / currentTotal) * 100)}`
  else if (currentTotal > previousTotal) return Math.round(((currentTotal - previousTotal) / previousTotal) * 100)
  else return 0
}

export const generateCsv = (props: any) => {
  const {
    deviceMetrics,
    connectorActivity,
    publisherMetrics,
    previousPublisherMetrics,
    totalSpaceMembers,
    previousTotalSpaceMembers,
    totalEngagedNow,
    totalEngagements,
    previousTotalEngagements,
    totalActivity,
    previousTotalActivity,
    totalEngagedUsers,
    previousTotalEngagedUsers,
    chatMetrics,
    previousChatMetrics
  } = props
  const { byDeviceData, hasMobile } = formatActivityByDevice(deviceMetrics, props.intl)
  const byDeviceMetrics = listMetrics('Member Activity By Device', byDeviceData)
  const byOsData = formatDataByOs(deviceMetrics, hasMobile, props.intl)
  const osMetrics = listMetrics('Member Activity By OS', byOsData)
  const notificationMetrics = listMetrics(SMART_NOTIFICATIONS_SENT, connectorActivity)
  const notificationTotals = sumConnectorData(connectorActivity)
  const publisherEngagement = sum([
    publisherMetrics?.urlVisit || 0,
    publisherMetrics?.detailViewed || 0,
    publisherMetrics?.actionSubmitted || 0
  ])
  const previousPublisherEngagement = sum([
    previousPublisherMetrics?.urlVisit || 0,
    previousPublisherMetrics?.detailViewed || 0,
    previousPublisherMetrics?.actionSubmitted || 0
  ])
  const spaceAnalytics = [
    '"Topic","Metric","Total","Change (If Applicable)"',
    `"Member Usage","Total Space Members",${totalSpaceMembers || 0},${calculateDifference(
      totalSpaceMembers,
      previousTotalSpaceMembers
    )}%`,
    `"Member Usage","Engaged Now",${totalEngagedNow || 0},""`,
    `"Member Usage","Unique Engaged Members",${totalEngagedUsers || 0},${calculateDifference(
      totalEngagedUsers,
      previousTotalEngagedUsers
    )}%`,
    `"Member Usage","Engagement",${totalEngagements || 0},${calculateDifference(
      totalEngagements,
      previousTotalEngagements
    )}%`,
    `"Member Usage","Total Activity",${totalActivity || 0},${calculateDifference(
      totalActivity,
      previousTotalActivity
    )}%`,
    byDeviceMetrics.join('\n'),
    osMetrics.join('\n'),
    notificationMetrics.join('\n'),
    `"Total Smart Notifications","Sent",${notificationTotals?.totalSent || 0}`,
    `"Total Smart Notifications","Viewed",${notificationTotals?.totalViewed || 0}`,
    `"Total Smart Notifications","Details Viewed",${notificationTotals?.totalDetailsViewed || 0}`,
    `"Total Smart Notifications","Clicked",${notificationTotals?.totalClicks || 0}`,
    `"Chatbot","Unique Members",${chatMetrics?.members || 0},${calculateDifference(
      chatMetrics?.members,
      previousChatMetrics?.members
    )}%`,
    `"Chatbot","Total Messages",${chatMetrics?.messages || 0},${calculateDifference(
      chatMetrics?.messages,
      previousChatMetrics?.messages
    )}%`,
    `"Chatbot","Sessions",${chatMetrics?.sessions || 0},${calculateDifference(
      chatMetrics?.sessions,
      previousChatMetrics?.sessions
    )}%`,
    `"Publisher Overview","Total Sent",${publisherMetrics?.sentNotifications || 0},${calculateDifference(
      publisherMetrics?.sentNotifications,
      previousPublisherMetrics?.sentNotifications
    )}%`,
    `"Publisher Overview","Unique Views",${publisherMetrics?.viewedNotifications || 0},${calculateDifference(
      publisherMetrics?.viewedNotifications,
      previousPublisherMetrics?.viewedNotifications
    )}%`,
    `"Publisher Overview","Interactions",${publisherEngagement},${calculateDifference(
      publisherEngagement,
      previousPublisherEngagement
    )}%`,
    `"Publisher Interactions","Opened Detail",${publisherMetrics?.detailViewed || 0},""`,
    `"Publisher Interactions","Clicked Links",${publisherMetrics?.urlVisit || 0},""`
  ].join('\n')
  return new Blob([spaceAnalytics])
}
